import PropTypes from 'prop-types';

const PersonIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33.9839142,23.507109 C33.6782842,23.3048973 33.3217158,23.3554502 33.0670241,23.5576619 C30.5201072,25.4281201 27.4128686,26.4897314 24,26.4897314 C20.5871314,26.4897314 17.4798928,25.3775671 14.9329759,23.5576619 C14.6782842,23.3554502 14.2707775,23.3554502 14.0160858,23.507109 C8.00536193,27.3491311 5,34.8815166 5,43.5260664 C5,49.4913112 43,49.4913112 43,43.5260664 C43,34.8815166 39.9946381,27.3491311 33.9839142,23.507109 Z M24,22.5466035 C30.2735402,22.5466035 35.3592493,17.4993744 35.3592493,11.2733017 C35.3592493,5.04722911 30.2735402,0 24,0 C17.7264598,0 12.6407507,5.04722911 12.6407507,11.2733017 C12.6407507,17.4993744 17.7264598,22.5466035 24,22.5466035 Z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

PersonIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

PersonIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default PersonIcon;
